import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutModule } from '@angular/cdk/layout';

import { HomePageRoutingModule } from './home-page-routing.module';
import { FormsModule } from '@angular/forms';
import { TranslocoModule } from '@ngneat/transloco';
import { MatIconModule } from '@angular/material/icon';
import { HomePageComponent } from './home-page.component';
import { EventCardCarouselComponent } from './components/event-card-carousel/event-card-carousel.component';
import { ScrollIndicatorComponent } from '../../ui/components/scroll-indicator/scroll-indicator.component';
import { SectionHeaderComponent } from '../../ui/components/section-header/section-header.component';
import { PrimaryButtonComponent } from '../../ui/components/primary-button/primary-button.component';
import { EventCategorySectionComponent } from './components/event-category-section/event-category-section.component';
import { EventCategorySelectorComponent } from './components/event-category-selector/event-category-selector.component';
import { EventCategorySelectorListComponent } from './components/event-category-selector-list/event-category-selector-list.component';
import { BigEventCardCarouselComponent } from './components/big-event-card-carousel/big-event-card-carousel.component';
import { DividerComponent } from '../../ui/components/divider/divider.component';
import { FloatingNavigationButtonComponent } from '../../ui/components/floating-navigation-button/floating-navigation-button.component';
import { LeftRightButtonPairComponent } from '../../ui/components/left-right-button-pair/left-right-button-pair.component';
import { StartDateComponent } from '../../ui/components/start-date/start-date.component';
import { BigEventCardComponent } from '../../ui/components/big-event-card/big-event-card.component';
import { LocationInfoComponent } from '../../ui/components/location-info/location-info.component';
import { CategorySectionHeaderComponent } from '../../ui/components/category-section-header/category-section-header.component';
import { EventCardComponent } from '../../ui/components/event-card/event-card.component';
import { SmallEventCardComponent } from '../../ui/components/small-event-card/small-event-card.component';
import { SelectableTextComponent } from '../../ui/components/selectable-text/selectable-text.component';
import { ResponsiveEventListComponent } from '../../ui/components/responsive-event-list/responsive-event-list.component';

@NgModule({
  declarations: [
    EventCardCarouselComponent,
    HomePageComponent,
    EventCategorySectionComponent,
    EventCategorySelectorComponent,
    EventCategorySelectorListComponent,
    BigEventCardCarouselComponent,
  ],
  imports: [
    CommonModule,
    LayoutModule,
    HomePageRoutingModule,
    FormsModule,
    TranslocoModule,
    MatIconModule,
    DividerComponent,
    FloatingNavigationButtonComponent,
    PrimaryButtonComponent,
    StartDateComponent,
    LocationInfoComponent,
    BigEventCardComponent,
    LeftRightButtonPairComponent,
    ScrollIndicatorComponent,
    SectionHeaderComponent,
    CategorySectionHeaderComponent,
    EventCardComponent,
    SmallEventCardComponent,
    SelectableTextComponent,
    ResponsiveEventListComponent,
  ]
})
export class HomePageModule { }
